import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/homepage');
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-primary via-secondary to-accent rounded-3xl p-8 md:p-12 lg:p-16 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10 text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <Icon name="Handshake" size={20} color="#ffffff" />
              <span className="text-white text-sm font-medium">Partnership Opportunities</span>
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
              Ready to Transform Your Business with
              <br />
              <span className="text-[#eaf4ff]">Enterprise-Grade Technology?</span>
            </h2>

            <p className="text-white/90 text-sm md:text-base lg:text-lg max-w-3xl mx-auto mb-8">
              Leverage our certified partnerships with Microsoft, Zoho, and Acronis to deliver comprehensive digital solutions. Get expert consultation and discover how our technology ecosystem can accelerate your transformation journey.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <Button
                variant="default"
                size="lg"
                onClick={handleContactClick}
                iconName="ArrowRight"
                iconPosition="right"
                className="bg-white text-primary hover:bg-white/90 min-w-[200px]"
              >
                Schedule Consultation
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/case-studies')}
                iconName="FileText"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10 min-w-[200px]"
              >
                View Case Studies
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6">
                <Icon name="Clock" size={32} color="#ffffff" className="mx-auto mb-3" />
                <div className="text-2xl md:text-3xl font-bold text-white mb-2">24/7</div>
                <div className="text-white/80 text-sm">Support Available</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6">
                <Icon name="Award" size={32} color="#ffffff" className="mx-auto mb-3" />
                <div className="text-2xl md:text-3xl font-bold text-white mb-2">15+</div>
                <div className="text-white/80 text-sm">Technology Partners</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6">
                <Icon name="TrendingUp" size={32} color="#ffffff" className="mx-auto mb-3" />
                <div className="text-2xl md:text-3xl font-bold text-white mb-2">98%</div>
                <div className="text-white/80 text-sm">Success Rate</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <div className="bg-card rounded-2xl p-6 shadow-md text-center hover:shadow-lg transition-shadow duration-300">
            <Icon name="Shield" size={40} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="text-base md:text-lg font-bold text-foreground mb-2">Enterprise Security</h3>
            <p className="text-sm text-text-secondary">Industry-leading cybersecurity and compliance</p>
          </div>
          <div className="bg-card rounded-2xl p-6 shadow-md text-center hover:shadow-lg transition-shadow duration-300">
            <Icon name="Zap" size={40} color="var(--color-accent)" className="mx-auto mb-4" />
            <h3 className="text-base md:text-lg font-bold text-foreground mb-2">Rapid Deployment</h3>
            <p className="text-sm text-text-secondary">Fast implementation with minimal disruption</p>
          </div>
          <div className="bg-card rounded-2xl p-6 shadow-md text-center hover:shadow-lg transition-shadow duration-300">
            <Icon name="Users" size={40} color="var(--color-secondary)" className="mx-auto mb-4" />
            <h3 className="text-base md:text-lg font-bold text-foreground mb-2">Expert Team</h3>
            <p className="text-sm text-text-secondary">Certified professionals across all platforms</p>
          </div>
          <div className="bg-card rounded-2xl p-6 shadow-md text-center hover:shadow-lg transition-shadow duration-300">
            <Icon name="BarChart3" size={40} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="text-base md:text-lg font-bold text-foreground mb-2">Proven Results</h3>
            <p className="text-sm text-text-secondary">Measurable ROI and business outcomes</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;